import ManageMedia from '~/api/manage_media';

export default {
    async getMediaFormWithoutMutations({state, commit}, id) {
        try {
            const media = await ManageMedia.getMediaForm(id || rootState.media.media.media_id);
            commit('media/updateMedia', media.media, {root: true});
        } catch (error) {
            console.error(error.message);
        }
    },

    publishBaseTemplate({state, commit, rootState}) {
        commit('updateIsPublishing', true);

        try {
            return ManageMedia.publishBaseTemplate(state.publishTemplateFormData)
        } catch (error) {
            commit('updateIsPublishing', false);
            throw new Error(error);
        } finally {
            commit('updateIsPublishing', false);
        }
    },

    unpublishBaseTemplate({state, commit, rootState}) {
        commit('updateIsPublishing', true);

        try {
            return ManageMedia.unpublishBaseTemplate(state.publishTemplateFormData)
        } catch (error) {
            commit('updateIsPublishing', false);
            throw new Error(error);
        } finally {
            commit('updateIsPublishing', false);
        }
    },

    async getStandardTemplateOrgs({state, commit}) {
        commit('updateIsLoading', true);

        try {
            const orgs = await ManageMedia.getStandardTemplateOrgs(state.publishTemplateFormData.media_id);
            commit('updateStandardOrgIds', orgs.organizations);
            return orgs;
        } catch (error) {
            throw new Error(error);
        } finally {
            commit('updateIsLoading', false);
        }
    }
};